import { render, staticRenderFns } from "./accountnote.vue?vue&type=template&id=3e678c73&"
import script from "./accountnote.vue?vue&type=script&lang=js&"
export * from "./accountnote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports